/**
 * @generated SignedSource<<460d032898e1f3408d64a969d523205d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperAssessmentRequestMutation$variables = {
  id: string;
};
export type PaperAssessmentRequestMutation$data = {
  readonly requestPaperAssessment: {
    readonly " $fragmentSpreads": FragmentRefs<"PaperAssessmentFragment">;
  };
};
export type PaperAssessmentRequestMutation = {
  response: PaperAssessmentRequestMutation$data;
  variables: PaperAssessmentRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaperAssessmentRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "requestPaperAssessment",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PaperAssessmentFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PaperAssessmentRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "requestPaperAssessment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assessmentRequestable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaperAssessment",
            "kind": "LinkedField",
            "name": "assessment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiLikelihood",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiUseDisclosed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiDisclosureQuote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "model",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arxivVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaperFlag",
                "kind": "LinkedField",
                "name": "flags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "detail",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73874eb09877ebb1aa11ff34bc84ab8b",
    "id": null,
    "metadata": {},
    "name": "PaperAssessmentRequestMutation",
    "operationKind": "mutation",
    "text": "mutation PaperAssessmentRequestMutation(\n  $id: ID!\n) {\n  requestPaperAssessment(id: $id) {\n    ...PaperAssessmentFragment\n    id\n  }\n}\n\nfragment PaperAssessmentFragment on Paper {\n  id\n  version\n  assessmentRequestable\n  assessment {\n    status\n    summary\n    aiLikelihood\n    aiUseDisclosed\n    aiDisclosureQuote\n    fullText\n    model\n    arxivVersion\n    flags {\n      kind\n      detail\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "994bb30370cb8d0a71de5dfbb6ec60bc";

export default node;
